// standin until data colors are in lib
export const rateCard1Color = '#26D990';
export const rateCard2Color = '#8080FF';
export const rateCardEqualColor = 'black';
